import React from 'react';
import './App.css'; // Importer le fichier CSS principal
import Calendar from './componentsJS/Calendar'; // Importer le chemin du calendrier
import Menu from './componentsJS/Menu'; // Importer la barre de menu
import HomePage from './componentsJS/HomePage'; // Importer la page d'acceuil
import AdminPage from './componentsJS/AdminPage'; // Importer la page d'admin
import Rgpd from './componentsJS/Rgpd'; // Importer la page d'admin
import { AuthProvider } from './auth/AuthProvider'; // Fournisseur de contexte pour l'authentification
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom'; // Importation de Router et Routes
// import Login from './auth/LoginPopup'; // Page de connexion (si tu en as une)

import { UserProvider } from './UserContext';


function App() {
  // Simulons une liste de 24 jours pour le calendrier
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  
  const AppContent = () => {
    const location = useLocation();
    return (
      <div className="App">
        {/* Masquer la barre de menu si l'URL est la page d'accueil ou de la page rgpd */}
        {location.pathname !== '/' && location.pathname !== '/Politique-de-confidentialite' && <Menu />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/main" element={<HomePage />} />
          <Route path="/calendrier" element={<Calendar days={days} />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/Politique-de-confidentialite" element={<Rgpd />} />
        </Routes>
      </div>
    );
  };

  return (
    <AuthProvider>
      <Router>
        <UserProvider>
          <AppContent />
        </UserProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;

